import React from "react";

const Loading = () => {
  return (
    <div className="form-container animate-pulse">
      <div className="register-form ">
        <div className="form-field"></div>
        <div className="form-field"></div>
        <div className="form-field"></div>
      </div>
    </div>
  );
};

export default Loading;
